import React from 'react';
import '../../css/main.css';
import Dictionary from '../main/Dictionary';
import MainHeader from './MainHeader';
import MainDisplay from './MainDisplay';

function Main(props) {

  return (
    <>
      <div id="main">

        <MainHeader allLevelStatus={props.allLevelStatus} selectedLevel={props.selectedLevel}/>
        <MainDisplay selectedLevel={props.selectedLevel} allCards={props.allCards}/>
        <Dictionary />

      </div>
    </>
  )
}

export default Main;
